import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.post("/statistics/Behavior/index",{...params
    } )
}
function GET_BTN(params) {
    return axios.post("/statistics/Behavior/getBtnList",{...params
    } )
}
function EXPORT(params) {
    return  axios.post("/statistics/Behavior/export",{ ...params
    }  )
}

export default {
    GET_LIST,
    EXPORT,
    GET_BTN
};
